import { useNavigate } from "react-router-dom";

const BASEURL = process.env.REACT_APP_BASE_URL;

const useUpdatePassword = () => {
  const navigate = useNavigate();

  const updatePassword = async (pBody:any) => {
    const res = await fetch(`${BASEURL}/v1/user/update-password`, {
      body: pBody,
      mode: "cors",
      headers: {
        //   Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      method: "PUT",
    });
    const result = await res.json();
    //   console.log("result", result)
    if (result.success) {
      navigate("/login");
    }
    return result;
  };

  return { updatePassword };
};

export default useUpdatePassword;
